

import { useEffect, useRef, useState } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5map from "@amcharts/amcharts5/map.js";
import map from "@amcharts/amcharts5-geodata/mexicoLow.js";
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting.js";
import { MyTheme } from "../../colors"; // Importar los colores definidos



export const InnovaZonaMexicoChart = ({ chartData, startDate, endDate }) => {
    const [chart, setChart] = useState(null);
    const chartDivId = useRef(`InnovaZonaMexicoChart-${Math.random().toString(36).substring(2, 11)}`); // Genera un ID único para cada gráfico
    const diaInicio = startDate
    const diaFin = endDate
    

    let catalogo = "";

    let banner = "innovasport"
    
    if (chartData.isInnova){
        banner = chartData.isInnova
    }


    if (chartData.show_graphic_graphic) {
        let newCatalogo = "innline_2025";
    

        if (newCatalogo && newCatalogo !== catalogo) {
            catalogo = 'C::OWN::' + newCatalogo;
        }
    }

    // "Tlaxcala": "MX-TLA",
    const stateMapping = {
        "zacatecas": "MX-ZAC",
        "yucatan": "MX-YUC",
        "veracruz": "MX-VER",
        "tamaulipas": "MX-TAM",
        "tabasco": "MX-TAB",
        "sonora": "MX-SON",
        "sinaloa": "MX-SIN",
        "san luis potosi": "MX-SLP",
        "quintana roo": "MX-ROO",
        "queretaro": "MX-QUE",
        "puebla": "MX-PUE",
        "oaxaca": "MX-OAX",
        "nuevo leon": "MX-NLE",
        "nayarit": "MX-NAY",
        "morelia": "MX-MOR",
        "michoacan": "MX-MIC",
        "estado de mexico": "MX-MEX",
        "jalisco": "MX-JAL",
        "hidalgo": "MX-HID",
        "guanajuato": "MX-GUA",
        "durango": "MX-DUR",
        "ciudad de mexico": "MX-CMX",
        "colima": "MX-COL",
        "coahuila": "MX-COA",
        "chihuahua": "MX-CHH",
        "chiapas": "MX-CHP",
        "campeche": "MX-CAM",
        "baja california sur": "MX-BCS",
        "baja california": "MX-BCN",
        "aguas calientes": "MX-AGU",
        "guerrero": "MX-GRO",

        "Aguascalientes": "MX-AGU",
        "Baja California": "MX-BCN",
        "Baja California Sur": "MX-BCS",
        "Campeche": "MX-CAM",
        "Chihuahua": "MX-CHH",
        "Chiapas": "MX-CHP",
        "Ciudad de México": "MX-CMX",
        "Coahuila": "MX-COA",
        "Colima": "MX-COL",
        "Durango": "MX-DUR",
        "Guerrero": "MX-GRO",
        "Guadalajara": "MX-GUA",
        "Hidalgo": "MX-HID",
        "Jalisco": "MX-JAL",
        "Estado de México": "MX-MEX",
        "Michoacán": "MX-MIC",
        "Morelia": "MX-MOR",
        "Nayarit": "MX-NAY",
        "Nuevo León": "MX-NLE",
        "Oaxaca": "MX-OAX",
        "Puebla": "MX-PUE",
        "Querétaro": "MX-QUE",
        "Quintana Roo": "MX-ROO",
        "Sinaloa": "MX-SIN",
        "San Luis Potosí": "MX-SLP",
        "Sonora": "MX-SON",
        "Tabasco": "MX-TAB",
        "Tamaulipas": "MX-TAM",
        "Tlaxcala": "MX-TLA",
        "Veracruz": "MX-VER",
        "Yucatán": "MX-YUC",
        "Zacatecas": "MX-ZAC"
    };

    const stateReportMap = {};
    const estadoAbreviadoYCompleto = []; // Nuevo arreglo para relacionar estados abreviados con sus nombres completos

    const estados = {
        "MX-AGU": "Aguascalientes",
        "MX-BCN": "Baja California",
        "MX-BCS": "Baja California Sur",
        "MX-CAM": "Campeche",
        "MX-CHH": "Chihuahua",
        "MX-CHP": "Chiapas",
        "MX-CMX": "Ciudad de México",
        "MX-COA": "Coahuila",
        "MX-COL": "Colima",
        "MX-DUR": "Durango",
        "MX-GRO": "Guerrero",
        "MX-GUA": "Guadalajara",
        "MX-HID": "Hidalgo",
        "MX-JAL": "Jalisco",
        "MX-MEX": "Estado de México",
        "MX-MIC": "Michoacán",
        "MX-MOR": "Morelia",
        "MX-NAY": "Nayarit",
        "MX-NLE": "Nuevo León",
        "MX-OAX": "Oaxaca",
        "MX-PUE": "Puebla",
        "MX-QUE": "Querétaro",
        "MX-ROO": "Quintana Roo",
        "MX-SIN": "Sinaloa",
        "MX-SLP": "San Luis Potosí",
        "MX-SON": "Sonora",
        "MX-TAB": "Tabasco",
        "MX-TAM": "Tamaulipas",
        "MX-TLA": "Tlaxcala",
        "MX-VER": "Veracruz",
        "MX-YUC": "Yucatán",
        "MX-ZAC": "Zacatecas"
    }


    function capitalizeWords(str) {
        return str
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    }

    chartData.data[0].data[2].forEach((subArray) => {
        let estado = "unknown";
        let tipoBanner = "unknown";


        subArray.forEach((item) => {
            if (item.key === catalogo) {

                estado = estados[item.value.replace(/type::/g, '').replace(/_/g, " ").split('::')[3]];
                tipoBanner = item.value.replace(/type::/g, '').replace(/_/g, " ").split('::')[1];

                if (estado !== "" && estado !== null && estado !== undefined && estado !== "none") {
                    estado = estado
                } else {
                    estado = "unknown";
                }

                

            }
        });

        
            const estadoKey = stateMapping[estado];

            if (estadoKey) {
                if (!stateReportMap[estadoKey]) {
                    stateReportMap[estadoKey] = 0;
                }
                stateReportMap[estadoKey]++;
                estadoAbreviadoYCompleto.push({ abreviado: estadoKey, completo: estado });
            }
        
    });

   


    useEffect(() => {
        let newChart = null;

        const generateChart = async () => {
            try {
                var startDate = new Date(diaInicio).getTime();
                var endDate = new Date(diaFin).getTime();
                const endDatePlusOneDay = new Date(endDate);
                endDatePlusOneDay.setDate(endDatePlusOneDay.getDate() + 1);

                const root = am5.Root.new(chartDivId.current);
                root.setThemes([MyTheme.new(root)]);

                newChart = root.container.children.push(
                    am5map.MapChart.new(root, {
                        projection: am5map.geoMercator()
                    })
                );

                var bubbleSeries = newChart.series.push(
                    am5map.MapPointSeries.new(root, {
                        calculateAggregates: true,
                        valueField: "value",
                        polygonIdField: "id",
                    })
                );

                function interpolateColor(value, min, max) {
                    const segmentSize = (max - min) / 3;
                    const firstSegment = min + segmentSize;
                    const secondSegment = firstSegment + segmentSize;

                    if (value <= firstSegment) {
                        return "rgb(68, 203, 103)";
                    } else if (value <= secondSegment) {
                        return "rgb(254, 175, 0)";
                    } else {
                        return "rgb(222, 70, 61)";
                    }
                }

                const minLength = 1;

                const maxLength = Math.max(
                    ...Object.values(stateReportMap)
                        .map(cantidad => {
                            return typeof cantidad === 'number' ? cantidad : 0;
                        })
                );

                const finalMaxLength = maxLength === -Infinity ? 0 : maxLength;

                var polygonSeries = newChart.series.push(
                    am5map.MapPolygonSeries.new(root, {
                        geoJSON: map
                    })
                );

                polygonSeries.mapPolygons.template.setAll({
                    strokeWidth: 0.5,
                    stroke: root.interfaceColors.get("background"),
                    tooltipText: "{name}: {value}", // Mostrar nombre completo del estado
                    templateField: "polygonTemplate"
                });

                const processedData = Object.entries(stateReportMap).map(([estadoAbreviado, cantidadTotal]) => {
                    // Obtener el estado completo usando el mapeo stateMapping
                    const estadoCompleto = Object.keys(stateMapping).find(key => stateMapping[key] === estadoAbreviado) || estadoAbreviado;

                    // Asignar el color del polígono en base a la cantidad total
                    const polygonColor = interpolateColor(cantidadTotal, minLength, maxLength);

                    // Retornar el objeto con la estructura deseada
                    return {
                        id: estadoAbreviado, // Usar el código abreviado como ID (ej. MX-XXX)
                        name: estadoCompleto, // Usar el nombre completo del estado
                        value: cantidadTotal, // Cantidad total de reportes
                        polygonTemplate: {
                            fill: am5.color(polygonColor), // Color del polígono basado en el valor
                            tooltipText: `${estadoCompleto}: {value}` // Mostrar el nombre completo en el tooltip
                        }
                    };
                });






                const rango = (maxLength - minLength) / 3;

                // Contenedor de la leyenda
                var legendContainer = root.container.children.push(
                    am5.Container.new(root, {
                        layout: root.verticalLayout,
                        x: am5.p100,
                        centerX: am5.p100,
                        marginRight: 15,
                        y: am5.p50,
                        centerY: am5.p50
                    })
                );

                // Crear los items de la leyenda usando los rangos
                function createLegendItem(color, label, min, max) {
                    var legendItem = legendContainer.children.push(
                        am5.Container.new(root, {
                            layout: root.horizontalLayout,
                            paddingTop: 5,
                            paddingBottom: 5
                        })
                    );

                    // Crear el cuadro de color
                    legendItem.children.push(
                        am5.Rectangle.new(root, {
                            width: 15,
                            height: 15,
                            fill: am5.color(color),
                            stroke: am5.color(0x000000),
                            strokeWidth: 1
                        })
                    );

                    // Añadir el texto de la leyenda con valores redondeados hacia abajo
                    legendItem.children.push(
                        am5.Label.new(root, {
                            text: `${label}: ${Math.floor(min)} - ${Math.floor(max)}`,
                            x: 10,  // espacio entre el cuadro y el texto
                            y: -4,
                            fontSize: 14,
                            fill: am5.color(0x000000)
                        })
                    );
                }

                // Añadir los tres niveles de gravedad con los rangos
                createLegendItem(0x44CB67, "Cantidad de denuncias", minLength, minLength + rango);           // Verde
                createLegendItem(0xFEAF00, "Cantidad de denuncias", minLength + rango, minLength + 2 * rango); // Amarillo
                createLegendItem(0xDE463D, "Cantidad de denuncias", minLength + 2 * rango, maxLength);


                // Configura el color de fondo del mapa a negro para los estados sin datos
                polygonSeries.mapPolygons.template.setAll({
                    fill: am5.color(0xD3D3D3),
                    fillOpacity: 1,
                    strokeWidth: 0.5,
                    stroke: root.interfaceColors.get("background"),
                });

                // Asignar los datos procesados a la serie de polígonos
                polygonSeries.data.setAll(processedData);

                bubbleSeries.data.setAll(processedData);

                var exporting = am5plugins_exporting.Exporting.new(root, {
                    menu: am5plugins_exporting.ExportingMenu.new(root, {
                        align: "right",
                        valign: "bottom"
                    })
                });




                // Add legend
                newChart.legend = am5.Legend.new(root, {});

                newChart.appear(1000, 100);

                if (chart) {
                    chart.dispose();
                }

                setChart(newChart);
            } catch (error) {
                console.error("Error al cargar las bibliotecas de AmCharts:", error);
            }
        };


        generateChart();




        return () => {

            am5.array.each(am5.registry.rootElements, function (root) {
                if (root) {
                    if (root.dom.id == chartDivId.current) {
                        root.dispose();
                    }
                }
            });


            if (chart) {
                chart.dispose();
            }
        };
    }, [chartData, startDate, endDate]);

    return <div id={chartDivId.current} style={{ width: "100%", height: "500px" }}></div>;
};

export default InnovaZonaMexicoChart;